import React from "react";
import { FcAlarmClock, FcCalendar, FcList } from "react-icons/fc";
import { dateFormate } from "util/Util";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function EventInfo({ selectedEvent, projects, handleEdit, handleDelete }: any) {
  console.log("Selected Event: ", selectedEvent);
  // Prefer the projectName carried on the event itself; fall back to looking it
  // up in the assigned-projects list only when the event doesn't have it. This
  // avoids the crash when `data[0]` is undefined (project not in `projects`).
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const matchedProject = (projects || []).find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (project: any) => project.projectId === selectedEvent.projectId
  );
  const projectName =
    selectedEvent.projectName || matchedProject?.name || "—";

  return (
    <div className="">
      <div className="flex items-center justify-between">
        <div />
        <div className="flex flex-row space-x-2 ">
          <FaEdit
            onClick={() => {
              console.log("handleEdit called with:", selectedEvent);
              handleEdit(selectedEvent);
            }}
            size={20}
            className="cursor-pointer text-green-500 "
          />
          <RiDeleteBin6Line
            onClick={() => {
              handleDelete(selectedEvent.id);
            }}
            size={20}
            className="cursor-pointer text-red-500"
          />
        </div>
      </div>

      <p className="text-l text-gray-600 flex items-center mb-2	dark:text-white">
        <FcList size={20} className="me-2" /> Project Name : {projectName}
      </p>
      <p className="text-l text-gray-600 flex items-center mb-2	dark:text-white">
        <FcAlarmClock size={20} className="me-2" /> Hours : {selectedEvent.hour}
      </p>
      <p className="text-l text-gray-600 flex items-center	mb-2 dark:text-white">
        <FcCalendar size={20} className="me-2" /> Date :{" "}
        {dateFormate(selectedEvent.start)}
      </p>
      <div className="flex items-center justify-between mb-4">
        <textarea
          rows={4}
          className="block p-2.5 w-full text-lg text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
          value={selectedEvent.title}
          disabled
        />
      </div>
      <p className="text-gray-600 truncate">{selectedEvent.description}</p>
    </div>
  );
}

export default React.memo(EventInfo);
